import React from 'react';
import { CheckIcon } from 'lucide-react';
import { inclusions } from '../data/content';
export function Inclusions() {
  return <section aria-labelledby="inclusions-title" className="bg-paper" data-id="element-77" data-mp="3bua6prhp0f2b">
      <div className="mx-auto grid max-w-6xl gap-4 px-5 py-12 lg:grid-cols-[0.8fr_1.2fr] lg:py-24" data-id="element-78" data-mp="2xu7rkd0rrzqr">
        <div data-id="element-79" data-mp="31urslrogrni6">
          <h2 id="inclusions-title" className="font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-80" data-mp="31wciv53qwka8">
            Everything you’ll find inside
          </h2>
          <div className="mt-5 inline-flex items-baseline gap-3 rounded-2xl border-2 border-ink bg-kraft px-5 py-3 sm:mt-8 sm:px-6 sm:py-4" data-id="element-81" data-mp="3uki927dkj1hg">
            <span className="font-display text-5xl font-black" data-id="element-82" data-mp="3gsbqyfquukfd">160+</span>
            <span className="max-w-[9rem] text-sm font-medium leading-tight" data-id="element-83" data-mp="3kt425ejaezea">printable PDF pages</span>
          </div>
        </div>
        <ul className="grid gap-x-8 sm:grid-cols-2" data-id="element-84" data-mp="cd2elofilcty">
          {inclusions.map(item => <li key={item} className="flex items-start gap-3 border-b border-dashed border-kraft-dark/40 py-3 sm:py-4" data-id="element-85" data-mp="h5vjqdewan6k">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-rust-dark" strokeWidth={3} aria-hidden="true" data-id="element-86" data-mp="659anufaqcm3" />
              <span className="font-medium" data-id="element-87" data-mp="16eja439jfqd">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}